export { SubheaderDescriptionComponent } from './subheader/subheader-description/subheader-description.component';
export { SubheaderTitleComponent } from './subheader/subheader-title/subheader-title.component';
export { SubheaderComponent } from './subheader/subheader.component';
export { GoogleTranslatorComponent } from './google-translator/google-translator.component';
export { HeaderContainerComponent } from './header-container/header-container.component';
export { LanguageComponent } from './language/language.component';
export { A11yFontSizeComponent } from './a11y-font-size/a11y-font-size.component';
